<form [formGroup]="formGroupInput()">
  <div class="card">
    <div class="card-header">
      {{
        "registrationWizard.generalTermsAndContitionsForm.generalTermsAndConditions"
          | translate
      }}
    </div>
    <div class="card-body">
      <div class="notification my-2">
        <span class="icon bi-info-circle me-2"></span
        ><span class="text my-a">{{
          "registrationWizard.generalTermsAndContitionsForm.identifyDescription"
            | translate
        }}</span>
      </div>
      <div class="scrollbar contract my-3 p-3">{{ contractText() }}</div>
      <div class="row flex-between-center">
        <app-validated-checkbox
          [inputFormControl]="formGroupInput().controls.privacyPolicy"
          inputFormControlName="privacyPolicy"
          label="registrationWizard.generalTermsAndContitionsForm.acceptPrivacyPolicyDescription"
          [validationTrainslations]="{
            required: 'registrationWizard.concentIsRequired'
          }"
        ></app-validated-checkbox>
        <app-validated-checkbox
          [inputFormControl]="formGroupInput().controls.termsAndConditions"
          inputFormControlName="termsAndConditions"
          label="registrationWizard.generalTermsAndContitionsForm.acceptTermsAndConditionsDescription"
          [validationTrainslations]="{
            required: 'registrationWizard.concentIsRequired'
          }"
        ></app-validated-checkbox>
        <app-validated-checkbox
          [inputFormControl]="formGroupInput().controls.passwordInfo"
          inputFormControlName="passwordInfo"
          label="registrationWizard.generalTermsAndContitionsForm.acceptTwoFactorOnBankAccountAddedDescription"
          [validationTrainslations]="{
            required: 'registrationWizard.concentIsRequired'
          }"
        ></app-validated-checkbox>
        <app-validated-checkbox
          [inputFormControl]="formGroupInput().controls.lawInfo"
          inputFormControlName="lawInfo"
          label="registrationWizard.generalTermsAndContitionsForm.acceptLawInfo"
          [validationTrainslations]="{
            required: 'registrationWizard.concentIsRequired'
          }"
        ></app-validated-checkbox>
      </div>
    </div>
  </div>
</form>
